import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { connect } from 'react-redux';

import { CompanyDetailsIncorrect } from './companyDetailsIncorrect/CompanyDetailsIncorrect';
import DuplicateGuarantorError from './DuplicateGuarantorError/DuplicateGuarantorError';
import IncompleteCreditCheckError from './IncompleteCreditCheckError/IncompleteCreditCheckError';
import LimitedCompanyError from './LimitedCompanyError/LimitedCompanyError';
import { NoAffordabilityAssessment } from './NoAffordabilityAssessment/NoAffordabilityAssessment';
import NoDirectorDetailsError from './NoDirectorDetailsError/NoDirectorDetailsError';
import { SoleTraderAdditionalGuarantors } from './SoleTraderAdditionalGuarantors/SoleTraderAdditionalGuarantors';
import TechnicalError from './TechnicalError/TechnicalError';
import WrongDirectorDetailsError from './WrongDirectorDetailsError/WrongDirectorDetailsError';
import { ErrorSVG } from '../../../svgComponents';
import { getAmplitudeDefaultEventProperties } from '../../../tracking/amplitudeEvents';
import * as automatedLendingDecisionReducer from '../AutomatedLendingDecision.reducer';

const mapStateToProps = ({ automatedLendingDecision }) => ({
    errorCode: automatedLendingDecision.errorCode
});

class DecisionError extends React.Component {
    trackError = (errorCode) => {
        tracking.ampli.lendingDecisionErrored({
            'Error type': _.capitalize(_.startCase(errorCode)),
            ...getAmplitudeDefaultEventProperties()
        });
    };

    renderError = () => {
        const { errorCode } = this.props;
        this.trackError(errorCode);

        switch (errorCode) {
            case automatedLendingDecisionReducer.COMPANY_NOT_FOUND_ERROR:
                return <LimitedCompanyError />;
            case automatedLendingDecisionReducer.DIRECTORS_COMPANY_MISMATCH_ERROR:
                return <WrongDirectorDetailsError />;
            case automatedLendingDecisionReducer.NO_DIRECTORS_ERROR:
                return <NoDirectorDetailsError />;
            case automatedLendingDecisionReducer.INCOMPLETE_CREDIT_CHECK_ERROR:
                return <IncompleteCreditCheckError />;
            case automatedLendingDecisionReducer.DUPLICATE_GUARANTORS_ERROR:
                return <DuplicateGuarantorError />;
            case automatedLendingDecisionReducer.SOLE_TRADER_ADDITIONAL_GUARANTORS:
                return <SoleTraderAdditionalGuarantors />;
            case automatedLendingDecisionReducer.NO_AFFORDABILITY_ASSESSMENT:
                return <NoAffordabilityAssessment />;
            case automatedLendingDecisionReducer.COMPANY_DETAILS_INCORRECT:
                return <CompanyDetailsIncorrect />;
            case automatedLendingDecisionReducer.TECHNICAL_ERROR:
            default:
                return <TechnicalError />;
        }
    };

    render() {
        const error = this.renderError();

        return (
            <div
                className="description decision-error"
                data-testid="decision-error">
                <ErrorSVG />
                {error}
            </div>
        );
    }
}

export default connect(mapStateToProps)(DecisionError);
